import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

// Full article bodies stay on the server. Overview pages need only summaries,
// and an article visit transfers only the requested article's content.
export const getArticle = createServerFn({ method: "GET" })
  .inputValidator(z.object({ slug: z.string().min(1).max(200) }))
  .handler(async ({ data }) => {
    const { getArticleDetail } = await import("@/data/article-content");
    return getArticleDetail(data.slug);
  });
